import React from 'react';
import styles from './CRMIntegration.module.css';
import leadImg from '../../Images/leadimg.png';
import crmicons from '../../Images/crmicons.png';
import crmicon2 from '../../Images/crmicon2.png';
import crmicon3 from '../../Images/crmicon3.png';
import crmicon4 from '../../Images/crmicon4.png';
import faquestion from "../../Images/FAQ@4x 1.png";


const CRMIntegration = () => {
  return (
    <div className={styles.container}>
      {/* Section 1: Hero / Header */}
      <section className={styles.hero}>
        <div className={styles.herobackground}></div>
        <div className={styles.heroOverlay}></div>
        <div className={styles.heroContent}>
          <h1>AI Lead Agent – Seamless CRM Integration with ToxBox AI</h1>
          <p className={styles.subheadline}>
            Transform your CRM into a powerful lead conversion engine with AI-driven automation and insights.
          </p>
          <button className={styles.primaryButton}>Integrate Your CRM Now</button>
        </div>
      </section>

      <section className={styles.metaSection}>
        <h2>Meta Description</h2>
        <p>ToxBox AI’s CRM integration automates lead management, nurtures prospects, <br />and increases sales efficiency.</p>
      </section>


      {/* Section 2: Problem Statement */}
      <section className={styles.problemsection}>
        <h1>Stop Losing Leads Due to <br /> Disconnected Systems</h1>
        <p>Managing leads across multiple platforms is inefficient and error-prone. ToxBox AI integrates directly with your CRM,<br /> ensuring all leads are automatically captured, segmented, and nurtured without manual intervention</p>

        <div className={styles.ministate}>
          <ul className={styles.problemlist}>
            <h4>Mini Stats</h4>
            <li>Of leads are lost due to slow or inconsistent follow-ups by 60%</li>
            <li>AI-driven CRM integration improves lead conversion rates by up to 50%</li>
            <li>Educe manual lead management effort by 80%</li>
          </ul>
          <div className={styles.problemImg}>
            <img src={leadImg} alt="mini state" />
          </div>
        </div>
      </section>

      <div className={styles.leadsContainer}>
        <h2 className={styles.heading}>Connect, Automate, and Nurture Leads</h2>

        <div className={styles.leadsGrid}>
          {/* 1 */}
          <div className={styles.leadItem}>
            <p className={styles.leadsTitle}>1. CRM Integration</p>
            <div className={styles.leadCard}>
              <ul>
                <li>Sync ToxBox AI with popular CRMs: HubSpot, Salesforce, Zoho, Pipedrive, and more</li>
                <li>Capture leads from website forms, ad campaigns, and social channels</li>
              </ul>
            </div>
          </div>

          {/* 2 */}
          <div className={styles.leadItem}>
            <p className={styles.leadsTitle}>2. Automated Lead Segmentation</p>
            <div className={styles.leadCard}>
              <ul>
                <li>AI segments leads based on engagement, interest, and buying intent</li>
                <li>Prioritize high-value prospects for faster conversion</li>
              </ul>
            </div>
          </div>

          {/* 3 */}
          <div className={styles.leadItem}>
            <p className={styles.leadsTitle}>3. Personalized Follow-Ups</p>
            <div className={styles.leadCard}>
              <ul>
                <li>Automated emails, SMS, and chat outreach directly from CRM</li>
                <li>AI personalizes messaging based on lead data and behavior</li>
              </ul>
            </div>
          </div>

          {/* 4 */}
          <div className={styles.leadItem}>
            <p className={styles.leadsTitle}>4. Engagement Analytics</p>
            <div className={styles.leadCard}>
              <ul>
                <li>Monitor lead activity, response rates, and pipeline progression</li>
                <li>AI recommends optimal actions for nurturing and conversion</li>
              </ul>
            </div>
          </div>

          {/* 5 */}
          <div className={`${styles.leadItem} ${styles.centerItem}`}>
            <p className={styles.leadsTitle}>5. Continuous Nurturing</p>
            <div className={styles.leadCard}>
              <ul>
                <li>AI keeps leads engaged until they’re ready to buy</li>
                <li>Re-engage dormant leads automatically</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className={styles.aiSection}>
        <h2 className={styles.aiTitle}>Why AI-Powered Assessment Analysis?</h2>

        <div className={styles.aiGrid}>
          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={crmicons} alt="mini state" />
            </div>
            <h3>Increase Conversions</h3>
            <ul>
              <li>Engage leads consistently with personalized messages</li>
              <li>Prioritize the most promising prospects</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={crmicon2} alt="mini state" />
            </div>
            <h3>Better Insights</h3>
            <ul>
              <li>Track performance across campaigns and channels</li>
              <li>Optimize follow-ups based on AI recommendations</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={crmicon3} alt="mini state" />
            </div>
            <h3>Seamless Workflow</h3>
            <ul>
              <li>Unified lead management across CRM and website</li>
              <li>No more disconnected systems or missed leads</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={crmicon4} alt="mini state" />
            </div>
            <h3>Save Time</h3>
            <ul>
              <li>Reduce manual entry and repetitive tasks</li>
              <li>Let AI handle lead nurturing sequences</li>
            </ul>
          </div>
        </div>
      </section>

      <section className={styles.crmSection}>
        <div className={styles.crmLeft}>
          <h2 className={styles.title}>Works with Leading CRM Tools</h2>
          <ul className={styles.featureList}>
            <p>HubSpot</p>
            <li>Sync leads and automate campaigns</li>
            <p>Salesforce</p>
            <li>AI-driven follow-ups and pipeline tracking</li>
            <p>Zoho CRM</p>
            <li>Segment, nurture, and convert leads automatically</li>
            <p>Pipedrive, Freshsales, and more</p>
            <li>Flexible integration for any business</li>
          </ul>
        </div>

        <div className={styles.crmRight}>
          <div className={styles.testimonialBox}>
            <p>
              “After integrating <b>ToxBox AI</b> with Salesforce, Company X improved
              follow-up efficiency by <b>70%</b> in just <b>30 days</b>”
            </p>
            <button className={styles.connectBtn}>Connect Your CRM</button>
          </div>
        </div>
      </section>


      <section className={styles.testimonialSection}>
        <h2 className={styles.heading}>What Our Clients Say</h2>
        <div className={styles.testimonialContainer}>
          <div className={styles.testimonialCard}>
            <div className={styles.avatar}></div>
            <div className={styles.textContent}>
              <p className={styles.role}>Marketing Manager, TechCo</p>
              <p className={styles.feedback}>
                Integrating <b>ToxBox AI</b> with HubSpot automated our lead nurturing
                and boosted conversions.
              </p>
            </div>
          </div>

          <div className={styles.testimonialCard}>
            <div className={styles.avatar}></div>
            <div className={styles.textContent}>
              <p className={styles.role}>Sales Director, FinTechCorp</p>
              <p className={styles.feedback}>
                Salesforce integration with AI lead sequences saved us countless hours.
              </p>
            </div>
          </div>
        </div>
      </section>


      <div className={styles.faqContainer}>
        <div className={styles.left}>
          <img src={faquestion} alt="FAQ Illustration" className={styles.faqImg} />
        </div>

        <div className={styles.right}>
          <h2 className={styles.title}>Frequently Asked Questions</h2>

          <div className={styles.faqCard}>
            <h3>Which CRMs does ToxBox AI support?</h3>
            <p>
              HubSpot, Salesforce, Zoho, Pipedrive, Freshsales, and custom CRMs via API.
            </p>
          </div>

          <div className={styles.faqCard}>
            <h3>Can AI automate follow-ups within CRM?</h3>
            <p>
              Yes, ToxBox AI creates personalized sequences directly within your CRM.
            </p>
          </div>

          <div className={styles.faqCard}>
            <h3>Is lead data secure?</h3>
            <p>Yes, enterprise-grade security and GDPR-compliant.</p>
          </div>
        </div>
      </div>

      <section className={styles.section}>
        <h2>Flexible CRM Integration Plans</h2>
        <button className={styles.primaryButton}>Get Started</button>
      </section>

      <section className={styles.lstsection}>
        <h2>Supercharge Your CRM with ToxBox AI</h2>
        <p>Integrate your CRM, automate lead follow-ups, and boost conversions with
          AI-powered lead nurturing. <br />
          Start transforming your sales pipeline today.</p>

      </section>

    </div>
  );
};

export default CRMIntegration;